import {Box, makeStyles, Button, Grid, Typography} from "@material-ui/core";
import { AddBoxOutlined } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TopBar from "../../components/Common/TopBar";
import PublishIcon from '@material-ui/icons/Publish';
import SearchActionsSection from "../../components/DeliveryAreaManagement/SearchActionsSection";
import TableSection from "../../components/DeliveryAreaManagement/TableSection";
import { getOpenDeliveryAreaFormDialog, handleOpenDeliveryAreaFormDialog, showAlertSnackbar } from "../../reducers/uiSlice";
import {
    addNewZone,
    downloadZipCodeExcelBlob,
    enableZipCodes,
    getAllAirport,
    getAllZipCodes,
    getAllZone,
    getPartners,
    handleRowValues,
    modifyZipCodeInfo,
    modifyZoneDetailInfo,
    modifyZoneState,
    updateZipCodesExcel,
    addzipcode
} from "../../actions/deliveryAreaActions";
import CreateEditDialog from "../../components/DeliveryAreaManagement/CreateEditDialog";
import AssignmentDialog from "../../components/DeliveryAreaManagement/AssignmentDialog";
import { useToken } from "../../utilities/hooks";
import _ from 'lodash';
import { getBranchList } from "../../actions/commonAction";
import FullscreenLoading from "../../components/Common/FullscreenLoading";
import { getUserPreference } from '../../utilities/common';
import RefreshIcon  from '@material-ui/icons/Refresh';
import AddIcon   from '@material-ui/icons/Add';
import CloudDownloadIcon  from '@material-ui/icons/CloudDownload';
import UniDialog from "../../components/Common/UniDialog";
import {downloadPodQualityExcelBlob} from "../../actions/podQualityActions";

const MANAGER_ACCESS_ROLE = 309;

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    },
    topBarButton: {
        marginLeft: theme.spacing(2),
        color: 'unset',
        '&:hover': {
            color: theme.palette.text.primary
        }
    },
    buttonGroupStyle: {
        textAlign: 'right',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
}))

function DeliveryAreaManagement() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation('deliveryAreaManagement');
    const tokenContents = useToken();
    const userPref = getUserPreference();
    const authorizedWarehouses = tokenContents.warehouse;
    const [submitExcelType, setSubmitExcelType] = useState('');
    const branchList = useSelector(state => state.common.branches);
    const partners = useSelector(state => state.deliveryAreaReducer.getPartners);
    const airports = useSelector(state => state.deliveryAreaReducer.getAirports);
    const openModalObject = useSelector(getOpenDeliveryAreaFormDialog);
    const [openReplaceDialog, setOpenReplaceDialog] = useState(false);
    const [openDownLoadDialog, setOpenDownLoadDialog] = useState(false);
    const ableManagerAccess = tokenContents.uiAbilities.includes(MANAGER_ACCESS_ROLE);
    const [file,setFile]=useState([]);
    const zoneTypeList = [
        {
            id: 'Zone 1',
            text: 'Zone 1'
        },
        {
            id: 'Zone 2',
            text: 'Zone 2'
        },
        {
            id: 'Zone 3',
            text: 'Zone 3'
        }
    ];
    const manageIndices = {
        zipCodeSection: {
            id: 0,
            text: t('zip_code')
        },
        zoneSection: {
            id: 1,
            text: t('zone')
        }
    }
    const zipCodeList = [
        {
            id: 0,
            label: t('warehouse'),
            list: []
        },
        {
            id: 1,
            label: t('status'),
            list: [
                {
                    id: 0,
                    text: t('inactive')
                },
                {
                    id: 1,
                    text: t('active')
                }
            ]
        }
    ]
    const zoneList = [
        {
            id: 3,
            label: t('depart_airport'),
            list: []
        },
        {
            id: 4,
            label: t('destination_airport'),
            list: []
        },
        {
            id: 5,
            label: t('zone_type'),
            list: zoneTypeList
        }
    ]
    const zipCodeInput = [{
        index: 2,
        label: t('pattern')
    }, {
        index: 3,
        label: t('zip_code')
    }]
    const zoneInput = [{
        index:3,
        label: t('zone')
    }]

    const [manageIndex, setManageIndex] = useState('zipCodeSection');
    const [selectListGroup, setSelectListGroup] = useState(zipCodeList);
    const [inputList, setInputList] = useState(zipCodeInput);
    const [warehouses, setWarehouses] = useState([]);
    const [page, setPage] = useState(0);

    const [warehousesSearch, setWarehousesSearch] = useState();
    const [isEnabledSearch, setIsEnabledSearch] = useState();
    const [partnerIdSearch, setPartnerIdSearch] = useState();
    const [patternIdSearch, setpatternIdSearch] = useState();
    const [zipCodeSearch, setZipCodeSearch] = useState();

    const [fromAirportSearch, setFromAirportSearch] = useState();
    const [toAirportSearch, setToAirportSearch] = useState();
    const [zoneTypeSearch, setZoneTypeSearch] = useState();
    const [zoneNameSearch, setZoneNameSearch] = useState();

    const [selected, setSelected] = useState();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const [allZipCodes, setAllZipCodes] = useState([]);
    const [allZone, setAllZone] = useState([]);



    const handleManageIndex = (event) => {
        setManageIndex(event.target.value);
    }
    const submitExcel = (file) => {
        if (submitExcelType !== 'replace') {
            handleUploadExcel(file[0])

        } else {
            setFile(file);
            setOpenReplaceDialog(true);
        }
    }
    const downloadZipFile = () => {
        setIsDataLoading(true);
        let params = {}
        if (!_.isNil(warehousesSearch)) {
            _.merge(params, {warehouse: warehousesSearch})
        }
        if (!_.isNil(isEnabledSearch)) {
            _.merge(params, {is_enabled: isEnabledSearch})
        }
        if (!_.isNil(patternIdSearch)) {
            _.merge(params, {pattern_id: patternIdSearch})
        }
        if (!_.isNil(zipCodeSearch)) {
            _.merge(params, {zipcode: zipCodeSearch})
        }
        downloadZipCodeExcelBlob(params)
            .catch((error) => {
                if (error?.status === 200) {
                    dispatch(showAlertSnackbar({message: t('no_data'), type: 'warning'}))
                } else {
                    dispatch(showAlertSnackbar({message: t('fetch_error'), type: 'error'}))
                }
            })
            .finally(() => {
                setIsDataLoading(false);
            })
    }
    const handleUploadExcel = (file) => {
        setIsSubmitLoading(true);
        dispatch(updateZipCodesExcel(file,submitExcelType,userPref.userCity))
        .then((res) => {
            dispatch(showAlertSnackbar({message: t('upload_success'), type: 'success'}))
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
        })
        .finally(() => {
            setIsSubmitLoading(false);
        })

    }
    const handleZipCodeSubmit = (paramsForm, zipcodeId) => {
        let params = {
            id: zipcodeId,
            zipcode: paramsForm['zipcode'],
            sorting_zone: paramsForm['sorting_zone'],
            city: paramsForm['city'],
            owner: paramsForm['owner'],
            is_remote: paramsForm['is_remote'] ? 1 : 0,
            route_no: paramsForm['route_no'],
            price: paramsForm['price'],
            is_enabled: paramsForm['is_enabled'] ? 1 : 0,
            pattern_id: paramsForm['pattern_id']
        }
        if (openModalObject?.type === 'create') {
            dispatch(addzipcode(params))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: t('add_success'), type: 'success'}))
                    dispatch(handleOpenDeliveryAreaFormDialog({open: false}));

                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
        } else {
            dispatch(modifyZipCodeInfo(params))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: t('edit_success'), type: 'success'}))
                    handleZipCodeSearch([warehousesSearch, isEnabledSearch, partnerIdSearch, zipCodeSearch], false);
                    dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
        }
    }
    const handleZoneSubmit = (paramsForm) => {
        let params = {
            zone_name: paramsForm['zone_name'],
            zone_type: paramsForm['zone_type'],
            from_airport: paramsForm['from_airport']?('UN-'+paramsForm['from_airport']):paramsForm['from_airport'],
            to_airport: paramsForm['to_airport']?('UN-'+paramsForm['to_airport']):paramsForm['to_airport'],
            is_active: 1
        }
        if(openModalObject?.type === 'create') {
            dispatch(addNewZone(params))
            .then((res) => {
                dispatch(showAlertSnackbar({message: t('create_success'), type: 'success'}))
                dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
        } else {
            dispatch(modifyZoneDetailInfo(params))
            .then((res) => {
                dispatch(showAlertSnackbar({message: t('edit_success'), type: 'success'}))
                dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
        }
        
    }
    const handleZipCodeSearch = (paramsForm, isFirstPage) => {
        setIsDataLoading(true);
        setWarehousesSearch(paramsForm[0]?.toString());
        setIsEnabledSearch(paramsForm[1]);
        setpatternIdSearch(paramsForm[2]);
        setZipCodeSearch(paramsForm[3]);
        if(isFirstPage) {
            setPage(1);
        }
        let params = {
            warehouse: paramsForm[0]?.toString(),
            is_enabled: paramsForm[1],
            pattern_id: paramsForm[2],
            zipcode: paramsForm[3],
            page: isFirstPage?1:page,
            size: 20
        }
        dispatch(getAllZipCodes(params))
        .then((res) => {
            setAllZipCodes(res);
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
        })
        .finally(() => {
            setIsDataLoading(false);
        })
    }
    const handleZoneSearch = (paramsForm, isFirstPage) => {
        setIsDataLoading(true);
        setFromAirportSearch(paramsForm[0]);
        setToAirportSearch(paramsForm[1]);
        setZoneTypeSearch(paramsForm[2]);
        setZoneNameSearch(paramsForm[3]);
        if(isFirstPage) {
            setPage(1);
        }
        let params = {
            from_airport: paramsForm[0]?('UN-'+paramsForm[0]):paramsForm[0],
            to_airport: paramsForm[1]?('UN-'+paramsForm[1]):paramsForm[1],
            zone_type: paramsForm[2],
            zone_name: paramsForm[3],
            page: isFirstPage?1:page,
            size: 20
        }
        dispatch(getAllZone(params))
        .then((res) => {
            setAllZone(res);
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
        })
        .finally(() => {
            setIsDataLoading(false);
        })
    }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    }
    const handleSelectedItems = (items) => {
        setSelected(items);
    }
    const handleActive = (isActivated) => {
        if(manageIndex === 'zipCodeSection') {
            let paramsZipCodes = {
                is_enabled: isActivated?1:0,
                zipcodes: selected?.toString()
            }
            dispatch(enableZipCodes(paramsZipCodes))
            .then(() => {
                dispatch(showAlertSnackbar({message: t('update_success'), type: 'success'}))
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
                handleZipCodeSearch([warehousesSearch, isEnabledSearch, patternIdSearch, zipCodeSearch], false);
            })
        } else {
            let paramsZone = {
                is_active: isActivated?1:0,
                zone_name: selected?.toString()
            }
            dispatch(modifyZoneState(paramsZone))
            .then(() => {
                dispatch(showAlertSnackbar({message: t('update_success'), type: 'success'}))
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
                handleZoneSearch([fromAirportSearch, toAirportSearch, zoneTypeSearch, zoneNameSearch], false);
            })
        }
    }
    const handleRowClick = (selectedRow) => {
        dispatch(handleRowValues(selectedRow.row));
        if(manageIndex === 'zipCodeSection') {
            dispatch(handleOpenDeliveryAreaFormDialog({open: true, id: 1, type: 'edit'}));
        } else {
            dispatch(handleOpenDeliveryAreaFormDialog({open: true, id: 2, type: 'edit'}));
        }
    }

    useEffect(() => {
        if(manageIndex) {
            setSelectListGroup(manageIndex==='zipCodeSection'?zipCodeList:zoneList);
            setInputList(manageIndex==='zipCodeSection'?zipCodeInput:zoneInput);
        }
    }, [manageIndex])
    useEffect(() => {
        if(authorizedWarehouses?.length > 0 && branchList?.length > 0) {
            let warehousesClone = [];
            authorizedWarehouses.map((branchId) => {
                let branch = branchList.find(o => o.id + '' === branchId + '');
                if(branch) {
                    warehousesClone.push(branch);
                }
            })
            setWarehouses(warehousesClone);
        }
    }, [authorizedWarehouses, branchList])
    useEffect(() => {
        dispatch(getBranchList());
        dispatch(getPartners());
        dispatch(getAllAirport());
        dispatch(handleOpenDeliveryAreaFormDialog({open: false, id: null, type: null}));
        setPage(0);
        setAllZipCodes([]);
        setAllZone([]);
    }, [])
    useEffect(() => {
        if(page !== 0) {
            if(manageIndex === 'zipCodeSection') {
                handleZipCodeSearch([warehousesSearch, isEnabledSearch, patternIdSearch, zipCodeSearch], false);
            } else {
                handleZoneSearch([fromAirportSearch, toAirportSearch, zoneTypeSearch, zoneNameSearch], false);
            }
        }
    }, [page])

    return (
        <Box className={classes.root}>
            <input
                color="primary"
                type="file"
                id="zip-code-file"
                onChange={(e) => submitExcel(e.target.files)}
                style={{display: 'none'}}
                disabled={!ableManagerAccess}
            />
            <TopBar
                title={t('delivery_area_management')}
                buttons={manageIndex==='zipCodeSection'?[
                    {
                        id: 1,
                        title: t('partners'),
                        props: {
                            startIcon: <img src='/images/icons/partners.svg' />,
                            onClick: ()=> dispatch(handleOpenDeliveryAreaFormDialog({open: true, id: 0}))
                        },
                        htmlFor: undefined
                    },
                    {
                        id: 2,
                        title: t('common:upload'),
                        props: {
                            startIcon: <PublishIcon/>,
                            onClick: () => {
                                setSubmitExcelType('upload')
                            },
                            htmlFor: 'zip-code-file',
                            disabled: !ableManagerAccess
                        }
                    },
                    {
                        id: 3,
                        title: t('common:update'),
                        props: {
                            startIcon: <AddIcon/>,
                            onClick: () => {
                                setSubmitExcelType('update')
                            },
                            htmlFor: 'zip-code-file',
                            disabled: !ableManagerAccess
                        }
                    },
                    {
                        id: 4,
                        title: t('common:replace'),
                        props: {
                            startIcon: <RefreshIcon/>,
                            onClick: () => {
                                setSubmitExcelType('replace')
                            },
                            htmlFor: 'zip-code-file',
                            disabled: !ableManagerAccess
                        }
                    },
                    {
                        id: 5,
                        title: t('common:download'),
                        props: {
                            startIcon: <CloudDownloadIcon/>,
                            onClick: () => setOpenDownLoadDialog(true),
                            disabled: _.isNil(warehousesSearch) && _.isNil(isEnabledSearch) && _.isNil(patternIdSearch) && _.isNil(zipCodeSearch)
                        },
                        htmlFor: undefined
                    }
                    ,
                    {
                        id: 5,
                        title: t('common:insert'),
                        props: {
                            startIcon: <AddBoxOutlined/>,
                            onClick: () => dispatch(handleOpenDeliveryAreaFormDialog({open: true, id: 1, type: 'create'}))
                         },
                        htmlFor: undefined
                    }
                ]:[
                    {
                        id: 3,
                        title: t('new_zone'),
                        props: {
                            startIcon: <AddBoxOutlined />,
                            onClick: ()=> dispatch(handleOpenDeliveryAreaFormDialog({open: true, id: 2, type: 'create'}))
                        },
                        htmlFor: undefined
                    }
                ]}
                buttonClasses={classes.topBarButton}
                appBarClasses={classes.appBarClasses}
                handleRadioChange={handleManageIndex}
                radios={manageIndices}
                radio={manageIndex}
            />
            <SearchActionsSection
                selectListGroup={selectListGroup}
                inputList={inputList}
                onSearch={manageIndex==='zipCodeSection'?handleZipCodeSearch:handleZoneSearch}
                warehouses={warehouses}
                partners={partners}
                airports={airports}
                handleActive={handleActive}
                isSelected={selected?.length}
                type={manageIndex==='zipCodeSection'?'zipCode':'zone'}
            />
            <TableSection
                type={manageIndex==='zipCodeSection'?'zipCode':'zone'}
                setPage={handlePageChange}
                setSelectedItems={handleSelectedItems}
                page={page}
                handleRowClick={handleRowClick}
                isDataLoading={isDataLoading}
                allZipCodes={allZipCodes}
                allZone={allZone}
            />
            <CreateEditDialog 
                onSubmit={manageIndex==='zipCodeSection'?handleZipCodeSubmit:handleZoneSubmit}
                zoneTypeList={zoneTypeList}
                airports={airports}
                warehouses={warehouses}
            />
            <AssignmentDialog 
                warehouses={warehouses}
                partners={partners}
                authorizedWarehouses={authorizedWarehouses}
            />
            <FullscreenLoading open={isSubmitLoading} />
            <UniDialog
                open={openReplaceDialog}
                onClose={() => {
                    setFile([])
                    setOpenReplaceDialog(false)
                }}
                maxWidth='sm'
                fullWidth
                disableDefaultButtons
                title={t('replace_title')}
            > <Grid container spacing={1}>
                {t('replace_confirm') + " " + file[0]?.name + "?"}
            </Grid>
                <div className={classes.buttonGroupStyle}>
                    <Button
                        onClick={() => {
                            setFile([])
                            setOpenReplaceDialog(false)
                        }} autoFocus>
                        {t('cancel')}
                    </Button>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={() => {
                            handleUploadExcel(file[0])
                            setOpenReplaceDialog(false)
                        }}
                    >
                        {t('confirmed')}
                    </Button>
                </div>
            </UniDialog>
            <UniDialog
                open={openDownLoadDialog}
                onClose={() => {
                    setFile([])
                    setOpenDownLoadDialog(false)
                }}
                maxWidth='sm'
                fullWidth
                disableDefaultButtons
                title={t('download_title')}
            >
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('warehouse')}: </span>
                            {warehousesSearch || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('status')}: </span>
                            {isEnabledSearch || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('pattern_id')}: </span>
                            {patternIdSearch || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('zipcode')}: </span>
                            {zipCodeSearch || "N/A"}
                        </Typography>
                    </Grid>
                </Grid>
                <div className={classes.buttonGroupStyle}>
                    <Button
                        id='deliveryareamanagement-canceldownload-button'
                        onClick={() => {
                            setFile([])
                            setOpenDownLoadDialog(false)
                        }} autoFocus>
                        {t('cancel')}
                    </Button>
                    <Button
                        id='deliveryareamanagement-confirmeddownload-button'
                        color='primary'
                        variant='contained'
                        onClick={() => {
                            downloadZipFile()
                            setOpenDownLoadDialog(false)
                        }}
                    >
                        {t('confirmed')}
                    </Button>
                </div>
            </UniDialog>
        </Box>
    );
}

export default DeliveryAreaManagement;